import React from 'react';
import styled from 'styled-components';

const MainContent = styled.main`
  flex: 1;
  margin-top: 80px;
  min-height: calc(100vh - 80px);
  background: linear-gradient(135deg, #f8fafc 0%, #eef2ff 50%, #f8fafc 100%);
  padding: 60px 20px;
`;

const Container = styled.div`
  max-width: 1100px;
  margin: 0 auto;
`;

const Title = styled.h1`
  font-size: 2.4rem;
  font-weight: 900;
  color: #0f172a;
  margin-bottom: 10px;
`;

const Subtitle = styled.p`
  color: #475569;
  font-size: 1.1rem;
  line-height: 1.6;
  max-width: 700px;
`;

const Card = styled.div`
  margin-top: 30px;
  background: white;
  border: 1px solid #e2e8f0;
  border-radius: 18px;
  padding: 24px;
  box-shadow: 0 10px 30px rgba(0,0,0,0.06);
`;

function AchatPage() {
  return (
    <MainContent>
      <Container>
        <Title>Service - Achat</Title>
        <Subtitle>
          Cette section est en cours de préparation.
        </Subtitle>
        <Card>
          <strong>En cours</strong>
        </Card>
      </Container>
    </MainContent>
  );
}

export default AchatPage;

